<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex">
          <DateSelect ref="dateFrom"/>
          <DateSelect ref="dateTo"/>
          <LoadingButton
            title="Показать"
            type="button"
            :loading="loading"
            :color="$constants.PRIMARY_COLOR"
            :onClick="() => showReport()"
            className="btn ml-1 btn-outline-info"
          />
        </div>
      </div>
    </div>
    <div v-if="!loading && ordersReport" class="flex">
      <Funnel
        type="post"
        :data="ordersReport.post"
      />
      <Funnel
        type="delivery"
        :data="ordersReport.delivery"
      />
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DateSelect from "@/views/reports/components/DateSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import moment from 'moment';
import Funnel from "@/views/reports/components/funnel/Funnel.vue";

export default {
  components: {Funnel, LoadingButton, DateSelect},
  data() {
    return {
      loading: false,
      ordersReport: null,
    }
  },
  methods: {
    async showReport() {
      this.loading = true;
      this.ordersReport = null;
      const range = {
        start: this.$refs.dateFrom.date,
        end: this.$refs.dateTo.date
      }
      let pass = true;
      Object.values(range).forEach((r) => {
        if (!r || moment(r, "DD.MM.YYYY").format("DD.MM.YYYY") !== r) {
          toastr['warning']('Дата периода не валидна');
          pass = false;
        }
      })
      const {data} = await api.post('/reports/sales/funnel', {
        range
      })
      if (data.success) {
        this.ordersReport = data.ordersReport;
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}

</script>
